import React from "react";
import {
  Box,
  Button,
  Typography,
  Chip,
} from "@mui/material";
import {
  Psychology,
} from "@mui/icons-material";


export default function AssessmentFilters({
  selectedAssessmentType,
  selectedGoals,
  onRadioToggle,
  dynamicAssessmentTypes = [],
}) {
  return (
    <Box>
      <Box sx={{ mb: 1.5 }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            color: "var(--clr-theme-gray-dark)",
          }}
        >
          Select Assessments
        </Typography>
      </Box>

      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 1.5 }}>
        {dynamicAssessmentTypes.map((type) => (
          <Button
            key={type}
            variant={selectedAssessmentType === type ? "contained" : "outlined"}
            size="small"
            onClick={() => onRadioToggle(type)}
            startIcon={<Psychology sx={{ fontSize: 18 }} />}
            sx={{
              textTransform: "none",
              backgroundColor:
                selectedAssessmentType === type ? "#666666" : "transparent",
              color: selectedAssessmentType === type ? "white" : "#666666",
              borderColor: "#666666",
              "&:hover": {
                backgroundColor:
                  selectedAssessmentType === type ? "#555555" : "#f5f5f5",
                borderColor: "#666666",
              },
            }}
          >
            {type}
          </Button>
        ))}
      </Box>


      {selectedGoals.length > 0 && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: 1,
            mt: 1,
          }}
        >
          <Chip
            label={`${selectedGoals.length} goal${
              selectedGoals.length > 1 ? "s" : ""
            } selected`}
            color="primary"
            variant="filled"
            size="small"
            sx={{
              backgroundColor: "#7b7add",
              color: "white",
              fontWeight: 600,
              fontSize: "0.875rem",
              "&:hover": {
                backgroundColor: "#6a69d9",
              },
              boxShadow: "0 2px 4px rgba(123, 122, 221, 0.3)",
            }}
          />
        </Box>
      )}
    </Box>
  );
}
